var map = {
	"./template.bet575": 1697,
	"./template.bet575.tsx": 1697,
	"./template.bet777": 1698,
	"./template.bet777.tsx": 1698,
	"./template.betgalaxy": 1699,
	"./template.betgalaxy.tsx": 1699,
	"./template.betprofessor": 2150,
	"./template.betprofessor.tsx": 2150,
	"./template.betroyale": 1700,
	"./template.betroyale.tsx": 1700,
	"./template.betstride": 1701,
	"./template.betstride.tsx": 1701,
	"./template.chromabet": 1702,
	"./template.chromabet.tsx": 1702,
	"./template.default": 676,
	"./template.default.tsx": 676,
	"./template.epicodds": 1703,
	"./template.epicodds.tsx": 1703,
	"./template.fiestabet": 2151,
	"./template.fiestabet.tsx": 2151,
	"./template.forsport": 1704,
	"./template.forsport.tsx": 1704,
	"./template.gigabet": 2152,
	"./template.gigabet.tsx": 2152,
	"./template.goldenbet888": 2153,
	"./template.goldenbet888.tsx": 2153,
	"./template.goldenrush": 2154,
	"./template.goldenrush.tsx": 2154,
	"./template.hyperbet": 2155,
	"./template.hyperbet.tsx": 2155,
	"./template.juicybet": 1705,
	"./template.juicybet.tsx": 1705,
	"./template.junglebet": 1706,
	"./template.junglebet.tsx": 1706,
	"./template.magnumbet": 1707,
	"./template.magnumbet.tsx": 1707,
	"./template.oldgill": 2156,
	"./template.oldgill.tsx": 2156,
	"./template.puntcity": 1708,
	"./template.puntcity.tsx": 1708,
	"./template.puntgenie": 1709,
	"./template.puntgenie.tsx": 1709,
	"./template.pyramidbet": 1710,
	"./template.pyramidbet.tsx": 1710,
	"./template.questbet": 2157,
	"./template.questbet.tsx": 2157,
	"./template.slambet": 2158,
	"./template.slambet.tsx": 2158,
	"./template.sterlingparker": 2159,
	"./template.sterlingparker.tsx": 2159,
	"./template.sugarcastle": 1711,
	"./template.sugarcastle.tsx": 1711,
	"./template.templebet": 1712,
	"./template.templebet.tsx": 1712,
	"./template.titanbet": 2160,
	"./template.titanbet.tsx": 2160,
	"./template.ts": 988,
	"./template.vikingbet": 1713,
	"./template.vikingbet.tsx": 1713,
	"./template.volcanobet": 1714,
	"./template.volcanobet.tsx": 1714,
	"./template.wellbet": 2161,
	"./template.wellbet.tsx": 2161
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 2474;